exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "legend[data-v-3bdd24a5]{font-size:13px;font-weight:700;border:0}fieldset>div[data-v-3bdd24a5]{background:#f4f4f4;border:1px solid #d3d6de;margin:0 15px 15px;padding:20px 20px 10px}@media (max-width:992px){legend[data-v-3bdd24a5]{text-align:left!important}}@media (min-width:992px){fieldset>div[data-v-3bdd24a5]{width:55%}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3bdd24a5","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/forms/asset-models/fieldset-default-values.vue
// module id = HB0T
// module chunks = 0